import KYCSumSubComponent from './KYCSumSubComponent';

export default KYCSumSubComponent;
